
export default {
  name: 'PagesAboutExtentionsUsersExperts',
  props: {
    title: {
      type: String,
      default: 'Эксперты на разные темы',
    },
  },
  data() {
    return {
      filter: 'ALL',
      experts: [],
      countAllExperts: 0,
      expertsLimit: 8,
      expertsOffet: 0,
      streams: [],
      countAllStreams: 0,
      streamsLimit: 4,
      streamsOffset: 0,
    }
  },
  async fetch() {
    await Promise.all([this.fetchCompanys(), this.fetchStreams()])
  },
  watch: {
    filter() {
      this.experts = []
      this.expertsOffet = 0
      this.fetchCompanys()
    },
  },

  methods: {
    userName(expert) {
      if (expert.type === 'COMPANY') {
        return expert.company?.title ? expert.company.title : expert.username
      } else {
        return expert.profile?.firstName && expert.profile?.lastName
          ? `${expert.profile.firstName} ${expert.profile.lastName}`
          : expert.username
      }
    },
    async fetchCompanys() {
      const { authors, countAllAuthors } = await this.$axios.$get(
        '/companys/about',
        {
          params: {
            limit: this.expertsLimit,
            offset: this.expertsOffet,
            filter: this.filter,
            type: 'COMPANY',
          },
        }
      )

      this.countAllExperts = countAllAuthors

      if (this.experts?.length) {
        this.experts = this.experts.concat(authors)
      } else {
        this.experts = authors
      }
    },
    async fetchStreams() {
      const { streams, countAllStreams } = await this.$axios.$get(
        '/streams/navigator',
        {
          params: {
            limit: this.streamsLimit,
            offset: this.streamsOffset,
            searchString: this.searchString,
          },
        }
      )

      if (this.streams?.length) {
        this.streams = this.streams.concat(streams)
      } else {
        this.streams = streams
      }
      this.streamsCount = countAllStreams
    },

    loadMore() {
      this.expertsOffet = this.expertsOffet + this.expertsLimit
      this.fetchCompanys()
    },
    loadMoreStreams() {
      this.streamsOffset = this.streamsOffset + this.streamsLimit
      this.fetchStreams()
    },
  },
}
